import './Radio.css';
export default {
    "root": "Radio_root__15qv4",
    "small": "Radio_small__15qv4",
    "input": "Radio_input__15qv4",
    "delegate": "Radio_delegate__15qv4",
    "large": "Radio_large__15qv4",
    "label": "Radio_label__15qv4"
};
